/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Export_Preset_Load_ConfirmInputs */



/**
* | output |
* | --- |
* | "Load" |
*
* @param {Video_Export_Export_Preset_Load_ConfirmInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_export_preset_load_confirm = /** @type {((inputs?: Video_Export_Export_Preset_Load_ConfirmInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Export_Preset_Load_ConfirmInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Charger")
	if (locale === "de") return /** @type {LocalizedString} */ ("Laden")
	if (locale === "it") return /** @type {LocalizedString} */ ("Carico")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Нагрузка")
	if (locale === "es") return /** @type {LocalizedString} */ ("Carga")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("加载")
	if (locale === "ja") return /** @type {LocalizedString} */ ("負荷")
	if (locale === "hi") return /** @type {LocalizedString} */ ("भार")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Carregar")
	return /** @type {LocalizedString} */ ("Load")
});